import React from "react";
import { InputAdornment, Input, Typography } from "@material-ui/core";

const InputText = (props) => {
  return (
    <Input
      value={props.value}
      style={{
        width: "100%",
        backgroundColor: props.color ? props.color : "",
      }}
      onChange={(e) => props.Change_Data(props.data_key, e.target.value)}
      multiline={typeof props.multiline ? true : false}
      readOnly={props.readonly ? true : false}
      startAdornment={
        props.data_key == "InkoopModel" || props.data_key == "Nieuwwaarde" ? (
          <InputAdornment position="start">
            <Typography style={{ color: "black" }}>€</Typography>
          </InputAdornment>
        ) : null
      }
    ></Input>
  );
};

export default InputText;
